import React, { useState, Fragment, useContext } from 'react';
import { func } from 'prop-types';
import useStyles from 'hooks/useStyles';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { BackIcon } from 'components/Icon';

import RatingModalContext from 'components/RatingModal/contexts/RatingModalContext';
import { TAG_CATEGORY_KEYS, GET_TAG_CATEGORY } from '../../constants';
import Scorer from '../Scorer';
import TagSelector from '../TagSelector';
import MultilineTextField from '../MultilineTextField';

import styles from './Form.scss';

const INITIAL_TAGS_INFO = TAG_CATEGORY_KEYS.map(key => ({
  key,
  selected: false,
}));

const Form = ({ onClose, onSubmit }) => {
  useStyles(styles);
  const { title, subTitle } = useContext(RatingModalContext);
  const { t } = useTranslation(['rating']);
  const [score, setScore] = useState(0);
  const [tagsInfo, setTagsInfo] = useState(INITIAL_TAGS_INFO);
  const [comment, setComment] = useState('');
  const showForm = Boolean(score);

  const handleTagSelectorClick = targetIndex => {
    setTagsInfo(prevTagsInfo =>
      prevTagsInfo.map((info, index) => {
        if (index !== targetIndex) return info;
        return {
          ...info,
          selected: !info.selected,
        };
      }),
    );
  };

  const handleSubmit = () => {
    const selectedTagsInfo = tagsInfo.filter(({ selected }) => selected);
    const selectedTagsInfoToString = selectedTagsInfo.map(({ key }) =>
      t(GET_TAG_CATEGORY(key)),
    );

    onSubmit({
      stars: score,
      tagsString: selectedTagsInfoToString.join(', '),
      comment,
    });
  };

  return (
    <Fragment>
      <span className={styles.back} onClick={onClose}>
        <BackIcon />
      </span>
      <h4>{title}</h4>
      <h6 className={styles.subTitle}>{subTitle}</h6>
      <Scorer className={styles.score} score={score} onScore={setScore} />
      {showForm && (
        <Fragment>
          <TagSelector tagsInfo={tagsInfo} onChange={handleTagSelectorClick} />
          <MultilineTextField
            placeholder={t('common.comment')}
            value={comment}
            onChange={setComment}
            maxRows={5}
          />

          <Button
            className={styles.submitButton}
            text={t('common.submit')}
            onClick={handleSubmit}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

Form.propTypes = {
  onClose: func.isRequired,
  onSubmit: func.isRequired,
};

export default Form;
